import { sapOdpMetadata } from 'app/registries/linked-service/sap-odp-metadata';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import {
    IDynamicLinkedServiceTypeMetadata,
    ILinkedServiceTypeMetadata
} from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { GlobalVariables } from 'app/services/globals';
import { ConnectionAuthKind, ConnectionKind } from 'shell-models-lib';
import { DataSourceOptionKind } from '@powerquery/mashup-editor-client';

/**
 * @deprecated
 */
export const sapCdcMetadata: IDynamicLinkedServiceTypeMetadata = async (injector) => {
    const metadata: ILinkedServiceTypeMetadata = {
        ...await sapOdpMetadata(injector),
        type: adfModelTypeMap.sapCdc.linkedServiceType,
        supportDataFlowSource: false,
        dataflowSource: undefined,
        notShowInTypeSelection: !GlobalVariables.enableSapCdcCopy,
        copySourceTypes: GlobalVariables.enableSapCdcCopy
            ? [adfModelTypeMap.sapCdc.copySourceType]
            : [],
        // #region Fabric
        supportedInTrident: true,
        supportOPDG: GlobalVariables.enableOPDG,
        supportedAuthKindsInTrident: [ConnectionAuthKind.Basic],
        supportOPDGInMirror: true,
        pqoDataSourceOption: {
            kind: DataSourceOptionKind.Extension,
            resourceKind: ConnectionKind.SAPCDC
        },
        supportCopyJobSource: true
        // #endregion
    };

    return metadata;
};
